export default __webpack_public_path__ + "static/media/ReportIcon-Brain-MS.d1cd62bc.jpg";